// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"337":"82b2f1bbe57c9849","888":"d4927c0da1728b4a"}[chunkId] + ".css";
};